module.exports = __webpack_public_path__ + "static/key-okami-75743d37db03a8699feb9214ffda48f8.webp";